export enum LearningNeed {
  ADHD = "adhd",
  Anxiety = "anxiety",
  ASD = "asd",
  DyslexiaDyscalculiaDysgraphia = "dyslexia_dyscalculia_dysgraphia",
  SpeechLanguageImpairment = "speech_language_impairment",
}

export const LearningNeedLabels: Record<LearningNeed, string> = {
  [LearningNeed.ADHD]: "ADHD",
  [LearningNeed.Anxiety]: "Anxiety",
  [LearningNeed.ASD]: "Autism Spectrum Disorder (ASD)",
  [LearningNeed.DyslexiaDyscalculiaDysgraphia]:
    "Dyslexia, Dyscalculia, or Dysgraphia",
  [LearningNeed.SpeechLanguageImpairment]: "Speech or Language Impairment",
};

export const LearningNeedsSelection = {
  ...LearningNeed,
  None: "none" as const,
} as const;

export const LEARNER_AGE_OF_MARKETING_CONSENT = 13;
